import { colors } from "./variables";
export default function processTreemapData(data, locale) {
    const total = data.items.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.montoOperado;
    }, 0);

    return [
        {
            name: data.titulo[locale],
            value: total,
            children: data.items.map((item) => {
                return {
                    name: item.simbolo,
                    value: item.montoOperado,
                    variation: item.variacion,
                    itemStyle: {
                        color:
                            item.variacion < 0
                                ? colors.graph_red
                                : item.variacion > 0
                                  ? colors.graph_green
                                  : colors.graph_blue,
                    },
                };
            }),
        },
    ];
}
